import { render, staticRenderFns } from "./page_owner.vue?vue&type=template&id=380d4fba&scoped=true&"
import script from "./page_owner.vue?vue&type=script&lang=js&"
export * from "./page_owner.vue?vue&type=script&lang=js&"
import style0 from "./page_owner.vue?vue&type=style&index=0&id=380d4fba&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d4fba",
  null
  
)

export default component.exports